export default __webpack_public_path__ + "static/media/dso.76ec71b6.png";